import React from 'react';
import '../css/MainSection.css';

import fundadorImg from '../img/rene.jpeg'; // ⚠️ Asegúrate de tener esta imagen

function MainSection() {
  return (
    <section className="about-section" id="nosostros">
      <h2 className="section-title">¿Quiénes somos?</h2>
      <div className="about-container">
        <div className="about-text">
          <p>
            Somos un emprendimiento nicaragüense nacido en Managua, fundado por <strong>René Gallegos</strong>, un apasionado del sabor auténtico y de las tradiciones del campo.
          </p>
          <p>
            Nuestro producto estrella: una salsa de <strong>chile cabro</strong> —como orgullosamente se le conoce en Nicaragua al chile habanero—, hecha con ingredientes naturales, sin conservantes artificiales y con una receta casera que resalta el verdadero picante de nuestra tierra.
          </p>
          <p>
            Esta salsa no solo pica: <em>cuenta una historia</em>. La historia de un emprendedor que, con esfuerzo y nobleza, quiere llevar el sabor de su país a cada rincón del mundo, manteniendo precios accesibles para que todos puedan disfrutar de ella.
          </p>
          <p>
            En cada frasco llevamos un pedacito de Nicaragua, con el orgullo de representar a nuestra gente, nuestros sabores y nuestros sueños.
          </p>
        </div>
        <div className="about-image">
          <img src={fundadorImg} alt="René Gallegos - Fundador" />
        </div>
      </div>
    </section>
  );
}

export default MainSection;